import React, { forwardRef, HTMLAttributes } from "react";
import { PageFooter } from "./PageFooter";
import styled from "styled-components";
import { onDesktop } from "../shared/layout/Breakpoints";
import PageCard from "./PageCard";

export interface PageProps {
  children: React.ReactNode;
  footer?: boolean;
  className?: string;
}

export const StyledPage = styled.div`
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${onDesktop`
    padding: 1em;
  `}
`;

export type PageRef = HTMLDivElement;

const Page = forwardRef<PageRef | null, PageProps>(function (
  { className, children, footer },
  ref
) {
  return (
    <>
      <StyledPage ref={ref} className={className}>
        {children}
      </StyledPage>
      {footer ? <PageFooter /> : null}
    </>
  );
});

export const PageContent = styled.div.attrs(
  (props: HTMLAttributes<HTMLDivElement>) => ({
    className: [props.className, "PageContent"].filter((c) => c).join(" "),
  })
)`
  width: 100%;
  max-width: 720px;

  &:last-child ${PageCard} {
    margin-bottom: 4em;
  }
`;

export default Page;
